module.exports = __webpack_public_path__ + "static/light-shadow-46538c245a8d57db3ae736ccae5ec743.svg";